/* eslint-disable */
import ItemBase from "./ItemBase";

class ItemOsmMapLine extends ItemBase {
  constructor(scene, mesh, points) {
    super(scene, mesh);
  }
}
export default ItemOsmMapLine;
